'use strict';

var Reflux             = require('reflux'),
    request            = require('superagent-promise'),
    STAGES             = require('js/shared/utils/application-stages.js'),
    ApplicationActions = require('js/shared/actions/application-actions.js');

/**
 * This store handles all user event tracking.
 **/
module.exports = Reflux.createStore({

    init: function () {

        // listenables
        this.listenTo(ApplicationActions.nextQuestionPage, this.onNextQuestionPage);
        this.listenTo(ApplicationActions.changeStage, this.onChangeStage);
        this.listenTo(ApplicationActions.homepageClick, this.onHomepageClick);
        this.listenTo(ApplicationActions.submitApplication, this.onSubmitApplication);
    },

    onSubmitApplication: function (options) {
        if (options.review === false) {
            ga('send', 'event', '2015_registration', 'click', 'registration-submit');
            ga('send', 'pageview', '/apply.html#2015_registration-submit');
        } else {
            ga('send', 'event', '2015_registration', 'click', 'registration-review-submit');
            ga('send', 'pageview', '/apply.html#2015_registration-review-submit');
        }
    },

    onChangeStage: function (stage) {
        switch (stage) {
            case STAGES.APPLICATION:
                ga('send', 'event', '2015_registration', 'click', 'registration-started');
                ga('send', 'pageview', '/apply.html#2015_registration-started');
                break;
            case STAGES.COMPLETED:
                ga('send', 'event', '2015_registration', 'click', 'registration-completed');
                ga('send', 'pageview', '/apply.html#2015_registration-completed');
                break;
            case STAGES.REVIEW:
                ga('send', 'event', '2015_registration', 'click', 'registration-review');
                ga('send', 'pageview', '/apply.html#2015_registration-review');
                break;
            case STAGES.SUBMITTED:
                ga('send', 'event', '2015_registration', 'click', 'registration-submit');
                ga('send', 'pageview', '/apply.html#2015_registration-submit');
                break;
            default:
                break;
        }
    },

    onNextQuestionPage: function (options) {
        ga('send', 'event', '2015_registration', 'click', 'registration-next-question-' + options.fieldName);
        ga('send', 'pageview', '/apply.html#2015_registration-next-question-' + options.fieldName);
    },

    onHomepageClick: function () {
        ga('send', 'event', '2015_registration', 'click', 'registration-goto-edit-application');
        ga('send', 'pageview', '/apply.html#2015_registration-goto-edit-application');
        window.location.assign("/application");
    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/stores/tracking-store.js
 ** module id = 244
 ** module chunks = 0 1 6
 **/